import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pt-14 pb-5 px-5" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex justify-start" }
const _hoisted_4 = { class: "relative h-42 w-288 me-3" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "px-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap max-w-6xl px-2 py-2 h-537" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full report-location-map" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "report-location-map",
      class: "w-full h-full overflow-auto"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_FilterPanel = _resolveComponent("FilterPanel")!
  const _component_DynamicTable = _resolveComponent("DynamicTable")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PageTitle, { title: "reports.DriversDelivery" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SearchInput, {
            placeholder: _ctx.$t('placeholders.username'),
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
          }, null, 8, ["placeholder", "modelValue"])
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFilterModal = true)),
          class: "border border-inputBorder w-42 h-42"
        }, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_BaseIcon, { name: "filter" })
          ])
        ]),
        (_ctx.showFilterModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_FilterPanel, {
                filters: _ctx.filters,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFilterModal = false)),
                onFetchData: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onExpandPanelClick($event)))
              }, null, 8, ["filters"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_DynamicTable, {
        scrollable: true,
        tableData: _ctx.reports,
        exportData: _ctx.exportReports,
        loading: _ctx.loading,
        reportType: _ctx.reportType,
        pagination: _ctx.pagination,
        tableFields: _ctx.tableFields,
        exportFields: [
        { id: 'driverId', name: 'Driver ID' },
        { id: 'driverName', name: 'Driver Name' },
        { id: 'driverFullName', name: 'Driver Full Name' },
        { id: 'createdAt', name: 'Date and time' },
        { id: 'darkstoreName', name: 'Darkstore' },
        { id: 'shiftName', name: 'Shift Name' },
        { id: 'shiftStartTime', name: 'shift s' },
        { id: 'shiftEndTime', name: 'shift e' },
        { id: 'orderId', name: 'Order' },
        { id: 'orderTotal', name: 'Order Total' },
        { id: 'distance', name: 'Distance' },
        { id: 'assignedTime', name: 'Assigned time' },
        { id: 'orderStatus', name: 'order Status' },
        { id: 'readyForPickupTime', name: 'Time (Ready to Pickup)' },
        { id: 'deliveryDuration', name: 'Time (Delivery Duration)' },
        { id: 'driverReturnDatetime', name: 'Driver Return Datetime' },
        { id: 'trackingId', name: 'Tracking Id' },
      ],
        buttons: { edit: true, delete: true, export: true},
        onSort: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickSort($event))),
        onMenuEvent: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuEvent($event))),
        onLocationClicked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.locationClick($event)))
      }, null, 8, ["tableData", "exportData", "loading", "reportType", "pagination", "tableFields", "exportFields"])
    ]),
    (_ctx.showLocationModal)
      ? (_openBlock(), _createBlock(_component_BaseModal, {
          key: 0,
          ref: "modal",
          title: 'Location',
          width: '860',
          onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showLocationModal = !_ctx.showLocationModal))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 64))
}